
const serviceUrl = 'http://localhost:56278';
export class CONFIG {
  public static baseUrls = {
    config: 'commands/config',
    //__________________ASMAA______________________
    hrEmpPromotion: `${serviceUrl}/api/v1/hrEmpPromotion`,
    HrJobAdvertisement: `${serviceUrl}/api/v1/HrJobAdvertisement`,
    salRepDesignUrl: `${serviceUrl}/api/v1/hrSalRepDesign`,
    glFinanceListReport: `${serviceUrl}/api/v1/glFinanceListReport`,
    glListNames: `${serviceUrl}/api/v1/glListNames`,
    branchesAccount: `${serviceUrl}/api/v1/branchesAccount`,
    attendMethod: `${serviceUrl}/api/v1/attendMethod`,
    hrVacNames: `${serviceUrl}/api/v1/HrVacNames`,
    hrLoanReason: `${serviceUrl}/api/v1/HrLoanReasons`,
    TableLevelDelete: `${serviceUrl}/api/v1/TableLevelDelete`,
    columnData: `${serviceUrl}/api/v1/columnData`,
    tableModule: `${serviceUrl}/api/v1/TableData`,
    tableModules: `${serviceUrl}/api/v1/TableModulesNull`,
    HrTaxesRule: `${serviceUrl}/api/v1/HrTaxesRule`,
    SubTaxMission: `${serviceUrl}/api/v1/SubTaxMission`,
    PoTaxesMission: `${serviceUrl}/api/v1/PoTaxesMission`,
    DocFeesTaxFile: `${serviceUrl}/api/v1/DocFeesTaxFile`,
    branches: `${serviceUrl}/api/v1/Branches`,
    hrSalItemLookUp: `${serviceUrl}/api/v1/hrSalItemLookUp`,
    vacAnnualOpenBal: `${serviceUrl}/api/v1/hrVacAnnualOpenBal`,
    vacationDepart: `${serviceUrl}/api/v1/vacationDepart`,
    hrEmpReHire: `${serviceUrl}/api/v1/hrEmpReHire`,
    copyEmpBasicSalary: `${serviceUrl}/api/v1/copyEmpBasicSalary`,
    copyEmpVariableSalary: `${serviceUrl}/api/v1/copyEmpVariableSalary`,
    hrFinancialIncreaseMaster: `${serviceUrl}/api/v1/hrFinancialIncreaseMaster`,
    rollBackCopy: `${serviceUrl}/api/v1/rollBackCopy`,
    HrTrainCourseAddvi: `${serviceUrl}/api/v1/HrTrainCourseAddviController`,
    HrEmpCourse: `${serviceUrl}/api/v1/HrEmpCourseController`,
    killLock: `${serviceUrl}/api/v1/KillLockController`,
    modifyPermissionForAllUsers: `${serviceUrl}/api/v1/ModifyPermissionForAllUsersController`,
    PromotionOfferStp: `${serviceUrl}/api/v1/PromotionOfferStp`,
    Blogs: `${serviceUrl}/api/v1/Blogs`,
    postOperativeEndorsement: `${serviceUrl}/api/v1/IcuProblems`,
    emrBloodChangeFormMaster: `${serviceUrl}/api/v1/EmrBloodChangeFormMaster`,

    icuProblem: `${serviceUrl}/api/v1/IcuProblems`,
    medicationReconciliation: `${serviceUrl}/api/v1/IcuProblems`,
    Meta: `${serviceUrl}/api/v1/Blogs`,
    About: `${serviceUrl}/api/v1/Blogs`,
    BlogsCategory: `${serviceUrl}/api/v1/Blogs`,
    EditnInvoice: `${serviceUrl}/api/v1/Blogs`,
    SmsMessage: `${serviceUrl}/api/v1/SmsMsg`,
    AppCodesStp: `${serviceUrl}/api/v1/AdmAppCodesStp`,
    secAppComp: `${serviceUrl}/api/v1/secAppCompController`,
    hrempAttendCards: `${serviceUrl}/api/v1/HrEmpAttendCardsController`,
    markExpectedServiceMaster: `${serviceUrl}/api/v1/MarkExpectedServiceMaster`,
    markPatExpectedService: `${serviceUrl}/api/v1/MarkPatExpectedService`,
    LeadAssignment: `${serviceUrl}/api/v1/LeadAssignment`,
    patCompinUrl: `${serviceUrl}/api/v1/RegPatVisitsCombineVisitSerial`,
    SupServiceBillExcUrl: `${serviceUrl}/api/v1/SupplierServiceBillExtract`,
    SlsServiceBillExcUrl: `${serviceUrl}/api/v1/ClientServiceBillExtract`,
    SupplierBillSchedualingUrl: `${serviceUrl}/api/v1/SupplierBillSchedualing`,
    PriOperDescriptionServices: `${serviceUrl}/api/v1/PriOperDescriptionServices`,
    PriPreOperativeOrders: `${serviceUrl}/api/v1/PriPreOperativeOrders`,
    MntPlanUrl: `${serviceUrl}/api/v1/MntPlan`,
    HrSalItemDepAccountUrl: `${serviceUrl}/api/v1/HRSalItemsDepartmentsAccounts`,
    _HrNursingIncentiveStp: `${serviceUrl}/api/v1/HrNursingIncentiveStp`,
    NicuVaccineSchedual: `${serviceUrl}/api/v1/NicuVaccineSchedual`,
    HrResidenceStp: `${serviceUrl}/api/v1/HrResidenceStp`,
    HrEmpOverTimeRequest: `${serviceUrl}/api/v1/HrEmpOverTimeRequest`,
    HrVacationRules: `${serviceUrl}/api/v1/HrVacationRules`,
    HrSecLoginJobPrevilag: `${serviceUrl}/api/v1/HrSecLoginJobPrevilag`,
    vechiles: `${serviceUrl}/api/v1/Vehicles`,
    glSisterAccountNumbersUrl: `${serviceUrl}/api/v1/GlSisterAccountNumbers`,
    GlCharts: `${serviceUrl}/api/v1/FZ_GlChart`,
    HrThumbMachineStpesRule: `${serviceUrl}/api/v1/HrThumbMachineStpesRule`,
    ClaimExcelColumnsUrl: `${serviceUrl}/api/v1/ClaimExcelColumns`,
    ClaimExcelTemplateURL: `${serviceUrl}/api/v1/ClaimExcelTemplate`,
    ClaimExcelTemplateColumnJoinUrl: `${serviceUrl}/api/v1/ClaimExcelTemplateColumnJoin`,
    ReviewPatientMedicalFileUrl: `${serviceUrl}/api/v1/ReviewPatientMedicalFile`,
    TransferringFromVisitToInsuarancePatientUrl: `${serviceUrl}/api/v1/TransferringFromVisitToInsuarancePatient`,
    HrServiceAwardReasons: `${serviceUrl}/api/v1/HrServiceAwardReasons`,
    HrServiceAwardSetup: `${serviceUrl}/api/v1/HrServiceAwardSetup`,
    HrSickLeavStp: `${serviceUrl}/api/v1/HrSickLeaveStp`,
    HrGeneralizationsAlertsSetup: `${serviceUrl}/api/v1/HrGeneralizationsAlertsSetup`,
    SaveCvDocument: `${serviceUrl}/api/v1/PortalGen`,
    HrEmpServiceAward: `${serviceUrl}/api/v1/HrEmpServiceAward`,
    HrEmployeePortal: `${serviceUrl}/api/v1/HrEmployeePortal`,
    crmSurvey: `${serviceUrl}/api/v1/CrmSurvey`,
    crmSurveyAnswer: `${serviceUrl}/api/v1/CrmSurveyAnswer`,
    crmTaskData: `${serviceUrl}/api/v1/CrmTaskData`,
    CrmComplaintClassification: `${serviceUrl}/api/v1/CrmComplaintClassification`,
    CrmComplaintsFollowUp: `${serviceUrl}/api/v1/CrmComplaintsFollowUp`,
    CrmMarketingCampaign: `${serviceUrl}/api/v1/CrmMarketingCampaign`,
    CrmTaskStage: `${serviceUrl}/api/v1/CrmTaskStage`,
    LabMappingSheetItem: `${serviceUrl}/api/v1/LabMappingSheetItem`,
    fhirUrl: `${serviceUrl}/api/v1/FhirController`,
    GLPeriodicJournalMaster: `${serviceUrl}/api/v1/GLPeriodicJournalMaster`,
    GLPeriodicJournalDetails: `${serviceUrl}/api/v1/GLPeriodicJournalDetails`,
    EmrNursPostSurgicalCarePlan: `${serviceUrl}/api/v1/EmrNursPostSurgicalCarePlan`,
    EditeSupplierName: `${serviceUrl}/api/v1/EmrNursPostSurgicalCarePlan`,
    sterilizationStepsSetup: `${serviceUrl}/api/v1/SterilizationStepsSetup`,
    HrEmpRequests: `${serviceUrl}/api/v1/HrEmpRequests`,
    HrSponsorData: `${serviceUrl}/api/v1/HrSponsorData`,
    salesOrderHistory: `${serviceUrl}/api/v1/salesOrderHistory`,
    PriChronicDiseaseSharePercentUrl: `${serviceUrl}/api/v1/PriChronicDiseaseSharePercent`,
    GenAirportStpUrl: `${serviceUrl}/api/v1/GenAirportStp`,
    PsMedicationErrorUrl: `${serviceUrl}/api/v1/PsMedicationError`,
    PsRapidResponseTeamCall: `${serviceUrl}/api/v1/PsRapidResponseTeamCall`,
    EmrFollowUpBloodTrnsfusion: `${serviceUrl}/api/v1/EmrFollowUpBloodTrnsfusion`,
    EmrPediatricEarlyWarningScoringSystem: `${serviceUrl}/api/v1/EmrPediatricEarlyWarningScoringSystem`,
    EmrTimeOutOutsideOperating: `${serviceUrl}/api/v1/EmrTimeOutOutsideOperating`,
    HrChangingNurses: `${serviceUrl}/api/v1/HrChangingNurses`,
    SecUserLoginJournal: `${serviceUrl}/api/v1/SecUserLoginJournal`,
    hrEducationalLinks: `${serviceUrl}/api/v1/HrEducationalLinks`,
    Companions: `${serviceUrl}/api/v1/AddEmpCompanions`,
    DocFeesUpdateSorting: `${serviceUrl}/api/v1/DocFeesUpdateSorting`,
    MalfunctionsCauses: `${serviceUrl}/api/v1/MalfunctionsCauses`,
    //__________________________END OF HR ENG.ASMAA____________________________
    securityCards: `${serviceUrl}/api/v1/CshVisaCardsType`,
    cshDollarDailyRate: `${serviceUrl}/api/v1/CshDollarDailyRate`,
    appCodes: `${serviceUrl}/api/v1/AppCodes`,
    alertsApiController: `${serviceUrl}/api/v1/AlertsApiController`,
    modules: `${serviceUrl}/api/v1/AppComponents`,
    linkDetails: `${serviceUrl}/api/v1/linkDetails`,
    common: `${serviceUrl}/api/v1/Common`,
    titles: `${serviceUrl}/api/v1/Titles`,
    maritals: `${serviceUrl}/api/v1/MaritalStatus`,
    countries: `${serviceUrl}/api/v1/Countries`,
    govsLink: `${serviceUrl}/api/v1/Govs`,
    identities: `${serviceUrl}/api/v1/IdentityType`,
    NphiesClaimValidation: `${serviceUrl}/api/v1/IdentityType`,
    villages: `${serviceUrl}/api/v1/Villages`,
    cities: `${serviceUrl}/api/v1/Cities`,
    patients: `${serviceUrl}/api/v1/Patients`,
    modifyPatientIdentity: `${serviceUrl}/api/v1/ModifyPatientIdentity`,
    companion: `${serviceUrl}/api/v1/Companion`,
    specials: `${serviceUrl}/api/v1/Specialties`,
    relativeCodes: `${serviceUrl}/api/v1/RelativeCodes`,
    favorites: `${serviceUrl}/api/v1/Favorites`,
    genLangStps: `${serviceUrl}/api/v1/GenLangStps`,
    clinics: `${serviceUrl}/api/v1/ClinicsSetting`,
    permissions: `${serviceUrl}/api/v1/Permissions`,
    branchModules: `${serviceUrl}/api/v1/BranchModules`,
    groupsData: `${serviceUrl}/api/v1/GroupsData`,
    SecUserLogins: `${serviceUrl}/api/v1/SecUserLogins`,
    //sayed
    secUsersPrivilege: `${serviceUrl}/api/v1/secUsersPrivilege`,
    costUrl: `${serviceUrl}/api/v1/fz_costs`,

    EmrSickLeaveApiurl: `${serviceUrl}/api/v1/EmrSickLeave`,
    portalNotificationSetup: `${serviceUrl}/api/v1/portalNotificationSetup`,
    leadsTypes: `${serviceUrl}/api/v1/portalNotificationSetup`,
    portalNotification: `${serviceUrl}/api/v1/PortalNotificationsAndMsgs`,
    users: `${serviceUrl}/api/v1/UsersData`,
    usersGroups: `${serviceUrl}/api/v1/UsersGroups`,
    groupIndicators: `${serviceUrl}/api/v1/GroupIndicators`,
    buildings: `${serviceUrl}/api/v1/Buildings`,
    buildingMap: `${serviceUrl}/api/v1/BuildingMap`,
    lookUps: `${serviceUrl}/api/v1/LookUpMasters`,
    lookUpDetails: `${serviceUrl}/api/v1/LookUpDetails`,
    nphiesCodeableSystemsMaster: `${serviceUrl}/api/v1/NphiesCodeableSystemsMasters`,
    nphiesCodeableSystemsDetail: `${serviceUrl}/api/v1/NphiesCodeableSystemsDetail`,
    admSearchAppCodes: `${serviceUrl}/api/v1/FastSearch`,
    employees: `${serviceUrl}/api/v1/Employees`,
    hrApplicantMainData: `${serviceUrl}/api/v1/HrApplicantMainData`,
    translations: `${serviceUrl}/api/v1/Translation`,
    settingsUrl: `${serviceUrl}/api/settings`,
    msgHeaders: `${serviceUrl}/api/v1/Glob_MSGHeaders`,
    msgDetails: `${serviceUrl}/api/v1/Glob_MSGDetails`,
    regFamilyDetails: `${serviceUrl}/api/v1/RegFamilyDetails`,
    auth: `${serviceUrl}/api/v1/Auth`,
    servicesSetting: `${serviceUrl}/api/v1/ServicesSetting`,
    PatientIncidentCategories: `${serviceUrl}/api/v1/PatientIncidentCategories`,
    serviceCompositeDetail: `${serviceUrl}/api/v1/PriServiceCompositeDetail`,
    categories: `${serviceUrl}/api/v1/Categories`,
    companyRules: `${serviceUrl}/api/v1/CompanyRules`,
    medicalsData: `${serviceUrl}/api/v1/MedicalsData`,
    dealsSetup: `${serviceUrl}/api/v1/DealsSetup`,
    priceLists: `${serviceUrl}/api/v1/PriceLists`,
    contractLists: `${serviceUrl}/api/v1/ContractListcopys`,
    cf_PriceLists: `${serviceUrl}/api/Cf_PriceLists`,
    companiesType: `${serviceUrl}/api/v1/CompaniesType`,
    clinicService: `${serviceUrl}/api/v1/ClinicService`,
    mainCompanies: `${serviceUrl}/api/v1/MainCompanies`,
    PriCompanyCheckList: `${serviceUrl}/api/v1/PriCompanyCheckList`,
    patientsStatus: `${serviceUrl}/api/v1/PatientsStatus`,
    companiesCategories: `${serviceUrl}/api/v1/CompaniesCategories`,
    servicesExceptions: `${serviceUrl}/api/v1/ServicesExceptions`,
    patentsCategories: `${serviceUrl}/api/v1/PatientsCategories`,
    jobCats: `${serviceUrl}/api/v1/JobCats`,
    reservationVisit: `${serviceUrl}/api/v1/ReservationVisit`,
    EligibilityNumber: `${serviceUrl}/api/v1/OutPatServiceRepeat`,
    clinicWorkSchedule: `${serviceUrl}/api/v1/ClinicWorkSchedule`,
    genSchRulesForReservation: `${serviceUrl}/api/v1/GenSchRulesForReservation`,
    outPatServiceRepeat: `${serviceUrl}/api/v1/OutPatServiceRepeat`,
    waitingAreaScreen: `${serviceUrl}/api/v1/WaitingAreaScreen`,

    unit: `${serviceUrl}/api/v1/Units`,
    redendancy: `${serviceUrl}/api/v1/Redendancies`,
    item: `${serviceUrl}/api/v1/Items`,
    group: `${serviceUrl}/api/v1/Groups`,
    priceListOutPatients: `${serviceUrl}/api/v1/PriceListOutPatients`,
    itemUnits: `${serviceUrl}/api/v1/ItemUnits`,
    itemsOfDepartment: `${serviceUrl}/api/v1/ItemsOfDepartment`, 
    itemOfDiagnosis: `${serviceUrl}/api/v1/ItemsOfDiagnosis`,
    druginterations: `${serviceUrl}/api/v1/DrugInteractions`,
    ItemDrugs: `${serviceUrl}/api/v1/ItemDrugs`,
    ItemManufacturing: `${serviceUrl}/api/v1/ItemManufacturing`,
    costCenters: `${serviceUrl}/api/v1/CostCenters`,
    empAppraisal: `${serviceUrl}/api/v1/HrEmpAppraisal`,
    applicantInterview: `${serviceUrl}/api/v1/HrApplicantInterview`,

    HospitalSetupModuleSetting: `${serviceUrl}/api/v1/HospitalSetup/ModuleSetting`,
    solution: `${serviceUrl}/api/v1/Solutions`,
    GenReceipTypeSetting: `${serviceUrl}/api/v1/GenReceipTypeSetting`,
    GenDefaultAlertStp: `${serviceUrl}/api/v1/GenDefaultAlertStp`,
    // ------------------------------------* Stoke ----------------------------------*
    ExtractionMedicationClaims: `${serviceUrl}/api/v1/ExtractionMedicationClaims`,
    MedicationDosesFav: `${serviceUrl}/api/v1/MedicationDosesFav`,
    Times: `${serviceUrl}/api/v1/Times`,
    stockModuleSetup: `${serviceUrl}/api/v1/StockModuleSetup`,
    StockTrans: `${serviceUrl}/api/v1/StockTransOpenBalance`,
    BfTransOpenBalance: `${serviceUrl}/api/v1/BfTransOpenBalance`,
    ArtificialMilkPreparing: `${serviceUrl}/api/v1/ArtificialMilkPreparing`,

    ChangeIncubatorForChildren: `${serviceUrl}/api/v1/ChangeIncubatorForChildren`,

    StockTransRasdIntegration: `${serviceUrl}/api/v1/StockTransRasdIntegration`,
    GenerateQrCode: `${serviceUrl}/api/v1/GenerateQrCode`,
    EmrToothNo: `${serviceUrl}/api/v1/EmrToothNo`,
    kitExchangePatMeals: `${serviceUrl}/api/v1/KitExchangePatMeals`,
    StrItemPlaces: `${serviceUrl}/api/v1/StrItemPlaces`,
    HrJobTitles: `${serviceUrl}/api/v1/HrJobTitles`,
    // ------------------------: `${serviceUrl}/api/v1/EmrToothNo`,------------* amer ----------------------------------*
    BillPatPricingRequest: `${serviceUrl}/api/v1/BillPatPricingRequest`,
    RegPatServiceWorkFlow: `${serviceUrl}/api/v1/RegPatServiceWorkFlow`,
    RegPatServiceDispatchRequest: `${serviceUrl}/api/v1/RegPatServiceDispatchRequest`,
    // ------------------------------------* Cashier Module ----------------------------
    nutrition: `${serviceUrl}/api/v1/Currencies`,
    // ------------------------------------* Cashier Module ----------------------------------*
    currencies: `${serviceUrl}/api/v1/Currencies`,
    cashiersData: `${serviceUrl}/api/v1/CashiersData`,
    cashierCurrencies: `${serviceUrl}/api/v1/CashierCurrencies`,
    cashierUsers: `${serviceUrl}/api/v1/CashierUsers`,
    inOutVariables: `${serviceUrl}/api/v1/InOutVariables`,
    visaTypes: `${serviceUrl}/api/v1/VisaTypes`,
    cashierTrans: `${serviceUrl}/api/v1/CashierTrans`,
    electronicInvoiceUrl: `${serviceUrl}/api/v1/ElectronicInvoiceUrl`,
    electronicReceiptUrl: `${serviceUrl}/api/v1/ElectronicReceiptUrl`,

    bank: `${serviceUrl}/api/v1/Bank`,
    cshDiscount: `${serviceUrl}/api/v1/Discounts`,
    DiscountRequests: `${serviceUrl}/api/v1/Discounts`,
    receiptInquery: `${serviceUrl}/api/v1/ReceiptInquery`,
    cancelationReasons: `${serviceUrl}/api/v1/CancelationReasons`,
    cshSetting: `${serviceUrl}/api/v1/CshSetting`,
    receiptPrint: `${serviceUrl}/api/v1/ReceiptPrint`,
    deposit: `${serviceUrl}/api/v1/Deposit`,
    CashierTrans: `${serviceUrl}/api/v1/CashierTrans`,
    cshVisaMachines: `${serviceUrl}/api/v1/CshVisaMachines`,
    cshCashierMachines: `${serviceUrl}/api/v1/CshCashierMachines`,

    cshDeductions: `${serviceUrl}/api/v1/CshDeductions`,
    cshClaims: `${serviceUrl}/api/v1/CshClaims`,
    // ------------------------------------------------------------------------------------------
    // ----------------------------------* CashPermission ------------------------------------------*
    cashPermission: `${serviceUrl}/api/v1/CashPermission`,
    payments: `${serviceUrl}/api/v1/CashPermission`,
    // ----------------------------------* Billing ------------------------------------------*
    patBill: `${serviceUrl}/api/v1/PatBill`,
    // ----------------------------------* Doctors Fees ------------------------------------------*
    DocFeesDetail: `${serviceUrl}/api/v1/DocFeesDetailModify`,
    docFeesSetting: `${serviceUrl}/api/v1/DoctorsFees`,
    // ----------------------------------* Planning ------------------------------------------*
    planning: `${serviceUrl}/api/v1/Planning`,
    // ----------------------------------* dynamic business rule ------------------------------------------*
    dbrUserRData: `${serviceUrl}/api/v1/DBRUserRData`,
    dBRUserRData: `${serviceUrl}/api/v1/DBRUserRData`,
    // ----------------------------------* Attendance ------------------------------------------*
    attendance: `${serviceUrl}/api/v1/Attendance`,
    // --------------------------------Rx--------------------------------------------------------*
    rx: `${serviceUrl}/api/v1/Rx`,
    PoOrderSupply: `${serviceUrl}/api/v1/PoOrderSupply`,
    HrSalItemGroups: `${serviceUrl}/api/v1/HrSalItemGroups`,
    // ----------------------------------------------------------------------------------------*
    // gl urls
    accountNumbers: `${serviceUrl}/api/v1/GlAccountNumbers`,
    financialYearsPeriods: `${serviceUrl}/api/v1/GlFinancialYearsPeriods`,
    glModuleValidation: `${serviceUrl}/api/v1/GlFinancialYearsPeriods`,
    codingSetup: `${serviceUrl}/api/v1/GlCodingSetup`,
    costCenterCoding: `${serviceUrl}/api/v1/CostCenterCoding`,
    Journals: `${serviceUrl}/api/v1/Journals`,
    GlDistributeExpenseAccountToCostCenters: `${serviceUrl}/api/v1/Journals`,
    glOpenBalance: `${serviceUrl}/api/v1/GlOpenBalance`,
    // ----------------------------------------------------------------------------------------
    // Assets urls
    assetsDeviceStp: `${serviceUrl}/api/v1/AssetsDeviceStp`,
    assetsDeviceServices: `${serviceUrl}/api/v1/AssetsDeviceServices`,
    // ----------------------------------------------------------------------------------------
    // order  urls
    ordering: `${serviceUrl}/api/v1/Ordering`,
    FollowUpToIntegrateWithPaxera: `${serviceUrl}/api/v1/Ordering`,
    ServicesNotFoundInIntegrationWithPaxera: `${serviceUrl}/api/v1/Ordering`,
    Rad: `${serviceUrl}/api/v1/Rad`,
    nurseDashboardPopup: `${serviceUrl}/api/v1/NurseDashboardPopup`,
    EmrRoasterNurse: `${serviceUrl}/api/v1/EmrRoasterNurse`,

    // ----------------------------------------------------------------------------------------
    // Lab  urls
    labSheetSetup: `${serviceUrl}/api/v1/Lab/Setup/Sheet`,
    labServiceSetup: `${serviceUrl}/api/v1/Lab/Setup/Service`,
    labGeneralSetup: `${serviceUrl}/api/v1/Lab/Setup/General`,
    labBloodExaminationSetup: `${serviceUrl}/api/v1/LabBloodExaminationSetup`,
    labTest: `${serviceUrl}/api/v1/Lab/Test`,
    labBloodExaminationResult: `${serviceUrl}/api/v1/labBloodExaminationResult`,
    ServiceHistory: `${serviceUrl}/api/v1/LabServiceHistory`,

    // ----------------------------------------------------------------------------------------
    ItemAlternatives: `${serviceUrl}/api/v1/ItemAlternatives`,
    StoresMainData: `${serviceUrl}/api/v1/StoresMainData`,
    dietsMainData: `${serviceUrl}/api/v1/dietsMainData`,
    tenders: `${serviceUrl}/api/v1/Tenders`,
    evaluationItems: `${serviceUrl}/api/v1/TendersEvaluationTerms`,
    tendersEvaluationItemsDetails: `${serviceUrl}/api/v1/TendersEvaluationItemsDetails`,
    tendersItems: `${serviceUrl}/api/v1/tendersItems`,
    tendersSuppliers: `${serviceUrl}/api/v1/tendersSuppliers`,
    tendersSuppliersEvaluation: `${serviceUrl}/api/v1/TenderSupplierEvaluation`,

    StoreGroups: `${serviceUrl}/api/v1/StoreGroups`,
    StrProfitMargin: `${serviceUrl}/api/v1/StrProfitMargin`,
    StockReplacementGuardianship: `${serviceUrl}/api/v1/StockReplacementGuardianship`,
    StockPermission: `${serviceUrl}/api/v1/StockPermission`,
    RequestNeeded: `${serviceUrl}/api/v1/RequestNeeded`,
    ExaminationSupply: `${serviceUrl}/api/v1/ExaminationSupply`,
    SupSupplierBill: `${serviceUrl}/api/v1/SupSupplierBill`,
    SlsClientBill: `${serviceUrl}/api/v1/SlsClientBill`,
    StoreUsers: `${serviceUrl}/api/v1/StoreUsers`,
    EmrPatComplains: `${serviceUrl}/api/v1/EmrPatComplains`,
    EmrpatGlassCard: `${serviceUrl}/api/v1/EmrpatGlassCard`,
    EmrPatFinding: `${serviceUrl}/api/v1/EmrPatFinding`,
    EmrPatDiagnosis: `${serviceUrl}/api/v1/EmrPatDiagnosis`,
    EmrPatAllergy: `${serviceUrl}/api/v1/EmrPatAllergy`,
    EmrProfileTaps: `${serviceUrl}/api/v1/EmrProfileTaps`,
    SecUserLoginEmrProfiles: `${serviceUrl}/api/v1/SecUserLoginEmrProfiles`,
    SecUserLoginDiscountReasons: `${serviceUrl}/api/v1/SecUserLoginDiscountReasons`,
    RxScheduledDoses: `${serviceUrl}/api/v1/RxScheduledDoses`,
    StrStoresDealWith: `${serviceUrl}/api/v1/StrStoresDealWith`,
    StoreItemsGroups: `${serviceUrl}/api/v1/StoreItemsGroups`,
    StrStoreItemSalePriceStp: `${serviceUrl}/api/v1/StrStoreItemSalePriceStp`,
    CshCashierUsersPreview: `${serviceUrl}/api/v1/CshCashierUsersPreview`,
    EmrOrItemCountSheet: `${serviceUrl}/api/v1/EmrOrItemCountSheet`,
    EmrIntensiveCareFlow: `${serviceUrl}/api/v1/EmrIntensiveCareFlow`,
    ///StrStoreItemSalePriceStp
    StrExaminationCommittee: `${serviceUrl}/api/v1/StrExaminationCommittee`,
    StoreExaminationCommitteeStp: `${serviceUrl}/api/v1/StrExaminationCommittee`,
    supplierType: `${serviceUrl}/api/v1/SupSupliersType`,
    supplierMainData: `${serviceUrl}/api/v1/SupSupliersMainData`,
    clientMainData: `${serviceUrl}/api/v1/ClientMainData`,
    PriServiceStpMedicalSteps: `${serviceUrl}/api/v1/PriServiceStpMedicalSteps`,
    PriContractOperSkills: `${serviceUrl}/api/v1/PriContractOperSkillStp`,
    HrMedicalSteps: `${serviceUrl}/api/v1/Hr_EmpMedicalSteps`,   //ABDO--NAME OF CONTROLLER ROUTE


    supSupplierOpenBalance: `${serviceUrl}/api/v1/SupSupplierOpenBalance`,
    slsClientOpenBalance: `${serviceUrl}/api/v1/SlsClientOpenBalance`,
    assets: `${serviceUrl}/api/v1/Assets`,

    SecGroupIndicators: `${serviceUrl}/api/v1/SecGroupIndicators`,

    EmrPatientEducation: `${serviceUrl}/api/v1/EmrPatientHealthEducation`,


    EmrPatGlasgowComaScale: `${serviceUrl}/api/v1/EmrPatGlasgowComaScale`,
    EmrPatBehavioralPainScale: `${serviceUrl}/api/v1/EmrPatBehavioralPainScale`,
    EmrPatNonverbalPainScale: `${serviceUrl}/api/v1/EmrPatNonverbalPainScale`,
    EmrPatFacePainScale: `${serviceUrl}/api/v1/EmrPatFacePainScale`,
    EmrBurnChart: `${serviceUrl}/api/v1/EmrBurnChart`,
    EmrPlasticSurgery: `${serviceUrl}/api/v1/EmrPlasticSurgery`,
    PriCompanyBranchPriceList: `${serviceUrl}/api/v1/PriCompanyBranchPriceList`,


    scheduling: `${serviceUrl}/api/v1/scheduling`,
    routeAdmin: `${serviceUrl}/api/v1/RouteAdmins`,
    priceListServices: `${serviceUrl}/api/v1/PriceListServices`,
    UsersPrivilege: `${serviceUrl}/api/v1/UsersPrivilege`,
    FavoriteListStp: `${serviceUrl}/api/v1/Doc_FavoriteListStp`,
    Sec_UserMedicalList: `${serviceUrl}/api/v1/Sec_UserMedicalList`,
    Sec_UserServices: `${serviceUrl}/api/v1/Sec_UserServices`,
    SecUserLoginRoles: `${serviceUrl}/api/v1/SecUserLoginRoles`,
    UsersService: `${serviceUrl}/api/v1/UsersService`,
    MedicalFilePlace: `${serviceUrl}/api/v1/MedicalFilePlace`,
    PatientFiles: `${serviceUrl}/api/v1/PatientFiles`,
    PatientFilesRequest: `${serviceUrl}/api/v1/PatientFilesRequest`,
    familyDetail: `${serviceUrl}/api/v1/RegFamilyDetails`,
    regpatHistoryOnOldSystem: `${serviceUrl}/api/v1/RegpatHistoryOnOldSystem`,
    conditions: `${serviceUrl}/api/v1/StorageConditions`,
    jobs: `${serviceUrl}/api/v1/Jobs`,
    jobsTypes: `${serviceUrl}/api/v1/JobsTypes`,
    PenPeriod: `${serviceUrl}/api/v1/PenPeriod`,
    infractions: `${serviceUrl}/api/v1/Infractions`,
    sanctions: `${serviceUrl}/api/v1/Sanctions`,
    qualificationcategories: `${serviceUrl}/api/v1/QualificationsCategories`,
    qualifications: `${serviceUrl}/api/v1/Qualifications`,
    colleges: `${serviceUrl}/api/v1/Colleges`,
    ambulances: `${serviceUrl}/api/v1/Ambulances`,
    universities: `${serviceUrl}/api/v1/Universities`,
    hr: `${serviceUrl}/api/v1/Hr`,
    hrPayrollDates: `${serviceUrl}/api/v1/HrPayrollDates`,
    penMasterLists: `${serviceUrl}/api/v1/PenMasterLists`,
    penDetailLists: `${serviceUrl}/api/v1/PenDetailLists`,
    resetValidationPeriods: `${serviceUrl}/api/v1/ResetViolations`,
    salaryItems: `${serviceUrl}/api/v1/SalaryItems`,
    empDateExpires: `${serviceUrl}/api/v1/EmpDateExpires`,
    dictionaries: `${serviceUrl}/api/v1/Dictionaries`,
    hrEmploymentData: `${serviceUrl}/api/v1/HrEmploymentData`,
    hrInsuranceRules: `${serviceUrl}/api/v1/HrInsuranceRules`,
    HrEmploymentDegree: `${serviceUrl}/api/v1/HrEmploymentDegree`,
    HrAppraisalGrades: `${serviceUrl}/api/v1/HrAppraisalGrades`,
    ModulesControl: `${serviceUrl}/api/v1/ModulesControl`,
    Cf_Contracts: `${serviceUrl}/api/v1/Cf_Contracts`,
    LoadEmpDataExcel: `${serviceUrl}/api/v1/LoadEmpDataExcel`,
    LoadClaimsDataExcel: `${serviceUrl}/api/v1/LoadClaimsDataExcel`,
    updateOfSaudiFoodAndDrugAuthoritylUrl: `${serviceUrl}/api/v1/LoadClaimsDataExcel`,
    ClaimsPaymentDatails: `${serviceUrl}/api/v1/ClaimsPaymentDatails`,
    Cf_PriceListItemsStp: `${serviceUrl}/api/v1/Cf_PriceListItemsStp`,
    Ps_IncidentData: `${serviceUrl}/api/v1/Ps_IncidentData`,
    PsESrrRoundStp: `${serviceUrl}/api/v1/PsESrrRoundStp`,
    HrExperience: `${serviceUrl}/api/v1/HrExperience`,
    NicuVaccinCondition: `${serviceUrl}/api/v1/NicuVaccinCondition`,
    NicuVaccinConditionMaster: `${serviceUrl}/api/v1/NicuVaccinConditionMaster`,
    BanksOpeningBalance: `${serviceUrl}/api/v1/BanksOpeningBalance`,
    BankExpensesStp: `${serviceUrl}/api/v1/BankExpensesStp`,
    OpeningBalanceForPaymentAndReceipts: `${serviceUrl}/api/v1/OpeningBalanceForPaymentAndReceipts`,
    BankExpensesStpTrans: `${serviceUrl}/api/v1/BankExpensesStpTrans`,
    PriCouponStp: `${serviceUrl}/api/v1/PriCouponStp`,
    MailsBox: `${serviceUrl}/api/v1/MailsBox`,//abdo
    BankTransformer: `${serviceUrl}/api/v1/BankTransformer`,
    HrTrainingCenter: `${serviceUrl}/api/v1/HrTrainingCenter`,
    HrTrainCourses: `${serviceUrl}/api/v1/HrTrainCourses`,
    HrTrainJobCourses: `${serviceUrl}/api/v1/HrTrainJobCourses`,
    PriOperDescription: `${serviceUrl}/api/v1/PriOperDescription`,
    hrEmpNotesForUser: `${serviceUrl}/api/v1/HrEmpNotesForUser`,

    HrAppraisalItemPreviewMaster: `${serviceUrl}/api/v1/HrAppraisalItemPreviewMaster`,
    HrAppraisalItemPreviewDetailed: `${serviceUrl}/api/v1/HrAppraisalItemPreviewDetailed`,
    EmrDrugInteractions: `${serviceUrl}/api/v1/EmrDrugInteractions`,
    HrAppraisalItemMaster: `${serviceUrl}/api/v1/HrAppraisalItemMaster`,
    HrContractMaster: `${serviceUrl}/api/v1/HrContractMaster`,
    HrAppraisalItemDetailed: `${serviceUrl}/api/v1/HrAppraisalItemDetailed`,
    HrContractDetailed: `${serviceUrl}/api/v1/HrContractDetail`,
    hrPayrollTypes: `${serviceUrl}/api/v1/hrPayrollTypes`,

    //   common: `${serviceUrl}/api/v1/Common`,
    fastSearch: `${serviceUrl}/api/v1/FastSearch`,
    patCancel: `${serviceUrl}/api/v1/PatCancel`,
    PatStopDeal: `${serviceUrl}/api/v1/PatStopDeal`,
    regPatVisit: `${serviceUrl}/api/v1/RegPatVisit`,
    moduleSetting: `${serviceUrl}/api/v1/RegModuleSetting`,
    discount: `${serviceUrl}/api/v1/DiscountSharePercent`,
    empQualification: `${serviceUrl}/api/v1/EmpQualification`,
    hrApplicantQualification: `${serviceUrl}/api/v1/HrApplicantQualification`,
    hrApplicantExperience: `${serviceUrl}/api/v1/HrApplicantExperience`,
    EmrPatVitals: `${serviceUrl}/api/v1/EmrPatVitals`,
    ICDDiagLookup: `${serviceUrl}/api/v1/ICDDiagLookup`,
    MEDFinding: `${serviceUrl}/api/v1/MEDFinding`,
    MEDComplain: `${serviceUrl}/api/v1/MEDComplain`,
    MEDHistory: `${serviceUrl}/api/v1/MEDHistory`,
    EmrDictionaryItemPropLOV: `${serviceUrl}/api/v1/EmrDictionaryItemPropLOV`,
    DoctorNurseNotes: `${serviceUrl}/api/v1/Reg_DoctorNurseNotes`,
    EmrNursingClinicalHandover: `${serviceUrl}/api/v1/EmrNursingClinicalHandover`,
    CodeBlueDocumentation: `${serviceUrl}/api/v1/EmrCodeBlueDocumentation`,

    EmrPatIntraTransferDetails: `${serviceUrl}/api/v1/EmrPatIntraTransferDetails`,
    EmrPatHistory: `${serviceUrl}/api/v1/EmrPatHistory`,
    EmrDiabeticChart: `${serviceUrl}/api/v1/EmrPatHistory`,
    hrEmployeeExperience: `${serviceUrl}/api/v1/HrEmployeeExperience`,
    billItem: `${serviceUrl}/api/v1/BillItem`,
    billItemGroups: `${serviceUrl}/api/v1/BillItemGroups`,
    medicalLetter: `${serviceUrl}/api/v1/MedicalLetter`,
    priLimits: `${serviceUrl}/api/v1/PriLimits`,
    inPatServ: `${serviceUrl}/api/v1/InPatServ`,
    PriServiceItemsStp: `${serviceUrl}/api/v1/PriServiceItemsStp`,
    residencedegree: `${serviceUrl}/api/v1/ResidenceDegree`,
    residencedegreepricing: `${serviceUrl}/api/v1/ResidenceDegreePricing`,
    PriComprehensiveExamination: `${serviceUrl}/api/v1/PriComprehensiveExamination`,
    priIdfSetting: `${serviceUrl}/api/v1/PriComprehensiveExamination`,
    PriComprehensiveRequest: `${serviceUrl}/api/v1/ComprehensiveRequest`,
    PriComprehensiveExaminPriceList: `${serviceUrl}/api/v1/PriComprehensiveExaminPriceList`,
    PriComprehensiveService: `${serviceUrl}/api/v1/PriComprehensiveService`,
    exceptions: `${serviceUrl}/api/v1/Exceptions`,
    TreatmentCards: `${serviceUrl}/api/v1/TreatmentCards`,
    AppCodePermission: `${serviceUrl}/api/v1/AppCodePermission`,
    RegstirationSteps: `${serviceUrl}/api/v1/RegstirationSteps`,
    DocManagment: `${serviceUrl}/api/v1/DocManagement`,
    DocFolderLookup: `${serviceUrl}/api/v1/DocFolderLookup`,
    PeriodicRestrictionsModels: `${serviceUrl}/api/v1/PeriodicRestrictionsModels`,
    DocManagmentLookup: `${serviceUrl}/api/v1/DocManagmentLookup`,
    managementSections: `${serviceUrl}/api/v1/Management`,
    CauseOfRefluxs: `${serviceUrl}/api/v1/CauseOfRefluxs`,
    operationsSkills: `${serviceUrl}/api/v1/OperationsSkills`,
    operPricing: `${serviceUrl}/api/v1/OperPricing`,
    ReportSetting: `${serviceUrl}/api/v1/RepMasterData`,
    employments: `${serviceUrl}/api/v1/HrEmploymentData`,
    EmrVenousConnections: `${serviceUrl}/api/v1/EmrVenousConnections`,
    EmrCriticalValuesReportingForm: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrPostFallProcedures: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrTeachingClinicalHandoverIsbar: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    // ------------------------------------------------------

    reportUrl: `${serviceUrl}/api/v1/Report`,
    // ------------------------------------------------------
    regPatService: `${serviceUrl}/api/v1/RegPatService`,
    orders: `${serviceUrl}/api/v1/Orders`,
    approvals: `${serviceUrl}/api/v1/Approvals`,
    /////----------------------------------------------------------
    PriServiceConditionStp: `${serviceUrl}/api/v1/PriServiceConditionStp`,
    priServiceRelatedWithCondion: `${serviceUrl}/api/v1/priServiceRelatedWithCondion`,
    /////----------------------------------------------------------
    accountBudgetSetup: `${serviceUrl}/api/v1/AccountsBudgetSetup`,


    // ------------------------------------------Claims------------------------*
    outPatClaims: `${serviceUrl}/api/v1/OutPatClaims`,
    inPatClaims: `${serviceUrl}/api/v1/InPatClaims`,
    openingBalance: `${serviceUrl}/api/v1/OpeningBalance`,
    claimMemo: `${serviceUrl}/api/v1/ClNotification`,
    clClaimNotification: `${serviceUrl}/api/v1/ClClaimNotification`,
    rejections: `${serviceUrl}/api/v1/Rejections`,
    naphisDocumentReview: `${serviceUrl}/api/v1/NaphisDocumentReview`,

    // --------------------------medical-recored--------------
    OPPatList: `${serviceUrl}/api/v1/OPPatientList`,
    // -----------------------medical sheets
    medicalSheets: `${serviceUrl}/api/v1/MedicalSheets`,
    emrCharts: `${serviceUrl}/api/v1/EmrCharts`,

    RegPatOperationToolsSupplies: `${serviceUrl}/api/v1/RegPatOperationToolsSupplies`,
    emrTaps: `${serviceUrl}/api/v1/emrTaps`,
    EmrSheetDictionarySerials: `${serviceUrl}/api/v1/EmrSheetDictionarySerials`,
    emrTapCategory: `${serviceUrl}/api/v1/EmrTapCategory`,
    emrProfile: `${serviceUrl}/api/v1/emrProfile`,
    emrSheets: `${serviceUrl}/api/v1/emrSheets`,
    emrPatNutritionType: `${serviceUrl}/api/v1/EmrPatNutritionType`,
    emrSheetsDictionary: `${serviceUrl}/api/v1/EmrSheetsDictionary`,
    emrDictionaryItemProps: `${serviceUrl}/api/v1/emrDictionaryItemProps`,
    emrHtmlTemplates: `${serviceUrl}/api/v1/EmrHtmlTemplates`,
    emrCAF: `${serviceUrl}/api/v1/EmrCAF`,
    emrOCAF: `${serviceUrl}/api/v1/EmrCAF`,
    EmrThromboembolicVteAdult: `${serviceUrl}/api/v1/EmrThromboembolicVteAdult`,

    EmrPreOperativeNursingAssessmentSheet: `${serviceUrl}/api/v1/EmrPreOperativeNursingAssessmentSheet`,
    //---------------------------Eng:-Mostafa--------------------------------
    fallRiskAssigment: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrLinkDiagnosticsToServices: `${serviceUrl}/api/v1/EmrLinkDiagnosticsToServices`,
    HumptyDumptyFallRiskScale: `${serviceUrl}/api/v1/FallRiskAssigment`,
    BradenQScale: `${serviceUrl}/api/v1/FallRiskAssigment`,
    DoctorOrders: `${serviceUrl}/api/v1/FallRiskAssigment`,
    OphthalmologyFollowUp: `${serviceUrl}/api/v1/OphthalmologyFollowUp`,
    SiteMarkingForm: `${serviceUrl}/api/v1/SiteMarkingForm`,
    BedsideTimeOut: `${serviceUrl}/api/v1/BedsideTimeOut`,
    SurveillanceForm: `${serviceUrl}/api/v1/SurveillanceForm`,
    emrPlanOfCareOnAdmission: `${serviceUrl}/api/v1/EmrPlanOfCareOnAdmission`,
    EmrConsultantDailyRound: `${serviceUrl}/api/v1/FallRiskAssigment`,
    MaturationalAssessment: `${serviceUrl}/api/v1/MaturationalAssessment`,
    AbdominalVisit: `${serviceUrl}/api/v1/AbdominalVisit`,
    EmrVentilationFlowSheet: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrCareMultidisciplinaryPlan: `${serviceUrl}/api/v1/EmrCareMultidisciplinaryPlan`,
    PreAnesthesiaRecording: `${serviceUrl}/api/v1/FallRiskAssigment`,
    PostAnesthesiaRecovery: `${serviceUrl}/api/v1/FallRiskAssigment`,
    fallRiskPrecautionsStp: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrHairTransplantation: `${serviceUrl}/api/v1/EmrHairTransplantation`,
    EmrHairTransplantationOperationDetails: `${serviceUrl}/api/v1/EmrHairTransplantationOperationDetails`,
    SafeSurgicalChecklist: `${serviceUrl}/api/v1/FallRiskAssigment`,
    UlcerFollowUp: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrHemodialysisUnit: `${serviceUrl}/api/v1/FallRiskAssigment`,
    OtolaryngologyHeadSheet: `${serviceUrl}/api/v1/OtolaryngologyHeadSheet`,
    OphthalmicSheet: `${serviceUrl}/api/v1/ophthalmicSheet`,
    ObstetricSheet: `${serviceUrl}/api/v1/ObstetricSheet`,
    neurologicalSheet: `${serviceUrl}/api/v1/NeurologicalSheet`,
    EmrRenalReplacementTherapyUnit: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrRenalReplacementTherapyUnitReferralSummary: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrRenalReplacementTherapyUnitDialysisOrderSheet: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrHealthInsuranceServices: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrMultidisciplinaryPlanOfCare: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrBedsoreFollowUp: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrPsychologicalFollowUpReport: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrGeneralPain: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrIntraOperativeAnesthesiaRecord: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrPreoperativeChecklist: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrcodeBlueForCpr: `${serviceUrl}/api/v1/EmrcodeBlueForCpr`,
    EmrReportOperative: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrPostOperativePlanOfCare: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrPostFallOccurrenceMedicalAssessment: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrInstructionsIsolatePatientWhenNecessary: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrOutpatientClinicNotes: `${serviceUrl}/api/v1/FallRiskAssigment`,
    EmrDailyPhysicalAssesment: `${serviceUrl}/api/v1/FallRiskAssigment`,
    dailyBradenScore: `${serviceUrl}/api/v1/DailyBradenScore`,
    emrPressureUlcerHealing: `${serviceUrl}/api/v1/EmrPressureUlcerHealing`,
    emrDrugsActiveMaterialsWithICDDiag: `${serviceUrl}/api/v1/EmrDrugsActiveMaterialsWithICDDiag`,
    emrEmergencyRoomPhysicianNotes: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrNutrationAssessmentPlan: `${serviceUrl}/api/v1/EmrNutrationAssessmentPlan`,
    EmrDiabeticTherapyRecord: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrConvulsionMonitoringForm: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    emrCardiacPatientAssessment: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    OutPatientNursingSheet: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrDyalisisUnitNursingAssessment: `${serviceUrl}/api/v1/EmrDyalisisUnitNursingAssessment`,
    EmrBreastfeedingUnitTransferForm: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrScreeningSheet: `${serviceUrl}/api/v1/EmrScreeningSheet`,
    emrFarmneoNutritionalRiskScreening: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    initialPhysicianAssessment: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrDesignHelper: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrComprehensiveEyeExamination: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrRiskScoreforTransportPatientsRSTPByPhysician: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    CardioPulmonaryResuscitionRecord: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    TelephoneMedicationOrder: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    IsolationDecisionPrecautions: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    PatientDefinition: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    PhysiotherapyInitialAssessment: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    EmrPhysiotherapyProgressNote: `${serviceUrl}/api/v1/EmrMedicalSheet`,
    // ------------------------------------------inpatient------------------------*
    inpatientreservation: `${serviceUrl}/api/v1/InPatient`,
    inpatientlist: `${serviceUrl}/api/v1/InPatient`,
    companionDischarge: `${serviceUrl}/api/v1/InPatient`,
    InPatientExitTemporary: `${serviceUrl}/api/v1/InPatient`,
    // InpatientSetting: `${serviceUrl}/api/v1/InPatient`
    ////asayed
    inpatientSetting: `${serviceUrl}/api/v1/InpatientSetting`,
    operationPlaceSetting: `${serviceUrl}/api/v1/operationPlaceSetting`,
    MarketingDepartmentofReferredDoctors: `${serviceUrl}/api/v1/operationPlaceSetting`,
    dBRDevR: `${serviceUrl}/api/v1/DBRDevR`,
    dBRUserR: `${serviceUrl}/api/v1/DBRUserR`,
    dBRUserRDetails: `${serviceUrl}/api/v1/DBRUserRDetails`,
    dBRDevRParms: `${serviceUrl}/api/v1/DBRDevRParms`,
    dBRDevROutput: `${serviceUrl}/api/v1/DBRDevROutput`,
    strItemCompositeStp: `${serviceUrl}/api/v1/StrItemCompositeStps`,
    SuplierItemsStp: `${serviceUrl}/api/v1/SuplierItemsStp`,
    supplierServices: `${serviceUrl}/api/v1/SupplierServices`,
    clientServices: `${serviceUrl}/api/v1/ClientServices`,
    genTemplate: `${serviceUrl}/api/v1/Hospital/Setup/Template`,
    vacation: `${serviceUrl}/api/v1/HR/Emp/Vacation`,
    //inpatLookUpDetails: `${serviceUrl}/api/v1/HR/Emp/InpatLookUpDetails`,
    priceinquery: `${serviceUrl}/api/v1/Ordering`,
    SupplierGroup: `${serviceUrl}/api/v1/SupplierGroup`,
    // ClientGroup: `${serviceUrl}/api/v1/ClientGroup`,
    docFeesAccordingRevenue: `${serviceUrl}/api/v1/DocFeesAccordingRevenue`,
    DocFeesWithWorkStaff: `${serviceUrl}/api/v1/DocFeesWithWorkStaff`,
    HrEmpVisaRequest: `${serviceUrl}/api/v1/HrEmpVisaRequest`,

    // --------------------Audits
    audits: `${serviceUrl}/api/v1/Audits`,
    dashBoradIndicators: `${serviceUrl}/api/v1/DashboardIndicators`,
    // ------------------------------------------Emergency------------------------*
    emergencyReservation: `${serviceUrl}/api/v1/Emergency`,
    EmrPatArrivalDetails: `${serviceUrl}/api/v1/EmrPatArrivalDetails`,

    // ------------------------------------------CallCenter------------------------*
    callCenter: `${serviceUrl}/api/v1/CallCenter`,
    // ------------------------------------------Maintainence------------------------*
    maintainRequest: `${serviceUrl}/api/v1/Maintainence`,
    marktingCalls: `${serviceUrl}/api/v1/MarktingCalls`,
    // ------------------------------------------Maintainence------------------------*
    labSignalrHub: `${serviceUrl}/labhub`,
    MessageHub: `${serviceUrl}/MessageHub`,
    ChatData: `${serviceUrl}/api/v1/Chat`,
    //---------------implementakstion------------------
    ModifyDelResidense: `${serviceUrl}/api/v1/ModifyDelResidense`,

    // ------------------------------------------specialized-emr------------------------*
    EmrNutrtionMedSheet: `${serviceUrl}/api/v1/MedicalSheets`,
    EmrNutrtionDietSystem: `${serviceUrl}/api/v1/EmrNutritionDietSystem`,
    EmrNutritionTypes: `${serviceUrl}/api/v1/NutritionTypes`,
    NutritionTypesDetails: `${serviceUrl}/api/v1/NutritionTypesDetails`,
    NutritionTypesItemsDetails: `${serviceUrl}/api/v1/NutritionTypesItemsDetails`,
    EmrPregnancyHistory: `${serviceUrl}/api/v1/EmrPregnancyHistroy`,

    emrErasCheckListOperativeUrl: `${serviceUrl}/api/v1/EmrErasCheckListOperative`,
    VatConsentLog: `${serviceUrl}/api/v1/VatConsentLog`,
    EmrOrCountSheet: `${serviceUrl}/api/v1/EmrOrCountSheet`,
    Chemotherapy: `${serviceUrl}/api/v1/EmrChemotherapyProtocolsSetup`,
    EmrSpecialtyVitalSetting: `${serviceUrl}/api/v1/EmrSpecialtyVitalsetting`,
    //=----------------------------------------loyality-----------------------------------------------//
    LoyalityMemberShip: `${serviceUrl}/api/v1/LoyalityMemberShip`,
    LoyaltyPointsRedemptionPolicy: `${serviceUrl}/api/v1/LoyalityMemberShip`,
    //---------------------------------------------------KPI--------------------//
    KpiSetting: `${serviceUrl}/api/v1/KpiSetting`,
    MedicalIndicatorsSettings: `${serviceUrl}/api/v1/KpiSetting`,
    //---------------------Hl7--------------------------------------------//
    hl7Orders: `${serviceUrl}/api/v1/Hl7Orders`,
    Nicu_Tpn: `${serviceUrl}/api/v1/Nicu_Tpn`,



    // -----------------Morgue-----------------------------------
    Morgue: `${serviceUrl}/api/v1/Morgue`,

    // -----------------Security-----------------------------------
    PowerBiReportSetting: `${serviceUrl}/api/v1/PowerBiDashboard`,

    // -----------------LaserDerma Alex-----------------------------------
    PortalPatientDashboard: `${serviceUrl}/api/v1/PortalPatientDashboard`,
    LaserAndDerma: `${serviceUrl}/api/v1/LaserAndDerma`,
    LaserClientHistory: `${serviceUrl}/api/v1/LaserAndDerma/ClientHistory`,
    LaserReservation: `${serviceUrl}/api/v1/LaserReservation`,
    LaserPackageOrAreaUnit: `${serviceUrl}/api/v1/LaserPackageOrAreaUnit`,
    laserPriceList: `${serviceUrl}/api/v1/laserPriceList`,
    laserSalesOrder: `${serviceUrl}/api/v1/laserSalesOrder`,
    EventSetup: `${serviceUrl}/api/v1/EventSetup`,
    LaserAdd: `${serviceUrl}/api/v1/LaserSetupAdd`,
    laserServicePerforming: `${serviceUrl}/api/v1/laserServicePerforming`,
    LaserAreas: `${serviceUrl}/api/v1/LaserSetupAreas`,
    laserBranches: `${serviceUrl}/api/v1/LaserSetupBranches`,
    laserClientStatus: `${serviceUrl}/api/v1/LaserSetupClientStatus`,
    laserConfirmationType: `${serviceUrl}/api/v1/LaserSetupConfirmationType`,
    laserDoctors: `${serviceUrl}/api/v1/LaserSetupDoctors`,
    laserDoctorsSchedule: `${serviceUrl}/api/v1/laserDoctorsSchedule`,
    laserDoctorsFees: `${serviceUrl}/api/v1/LaserSetupDoctorsFees`,
    laserDoctorFeesCalculationMetric: `${serviceUrl}/api/v1/laserDoctorFeesCalculationMetric`,
    laserEmployee: `${serviceUrl}/api/v1/LaserSetupEmployee`,
    laserGovernment: `${serviceUrl}/api/v1/LaserSetupGovernment`,
    laserPresenceType: `${serviceUrl}/api/v1/LaserSetupPresenceType`,
    laserResidntialArea: `${serviceUrl}/api/v1/LaserSetupResidntialArea`,
    laserSetupDermaService: `${serviceUrl}/api/v1/LaserSetupDermaService`,
    LaserSetupSessionType: `${serviceUrl}/api/v1/LaserSetupSessionType`,
    laserConfirmation: `${serviceUrl}/api/v1/laserConfirmation`,
    laserConfirmationAssignment: `${serviceUrl}/api/v1/LaserConfirmationAssignment`,
    laserConfirmationReassign: `${serviceUrl}/api/v1/LaserConfirmationReassign`,
    LaserConfirmationDoctorReplacement: `${serviceUrl}/api/v1/LaserConfirmationDoctorReplacement`,
    laserConfirmationSummury: `${serviceUrl}/api/v1/LaserConfirmationSummury`,
    laserSetupBodyPart: `${serviceUrl}/api/v1/LaserSetupBodyPart`,
    laserSetupUnits: `${serviceUrl}/api/v1/LaserSetupUnits`,
    laserSetupUnitsMeasure: `${serviceUrl}/api/v1/LaserSetupUnitsMeasure`,
    LaserSetupDermaUnits: `${serviceUrl}/api/v1/LaserSetupDermaUnits`,
    laserSetupDevices: `${serviceUrl}/api/v1/LaserSetupDevices`,
    laserSetupTarget: `${serviceUrl}/api/v1/LaserSetupTarget`,
    laserSetupTargetEmployee: `${serviceUrl}/api/v1/LaserSetupTargetEmployee`,
    laserSetupDepartment: `${serviceUrl}/api/v1/LaserSetupDepartment`,
    LaserSetupSkinCare: `${serviceUrl}/api/v1/LaserSetupSkinCare`,
    laserFeedbackStatus: `${serviceUrl}/api/v1/LaserSetupFeedbackStatus`,
    laserSetupPriceList: `${serviceUrl}/api/v1/LaserSetupPriceList`,

    ///////////////////////////////////Zatca
    ZatcaApprovalInvoiceStamping: `${serviceUrl}/api/v1/ZatcaApprovalInvoiceStamping`,
    CreateAndSignatureInvoiceZatca: `${serviceUrl}/api/v1/CreateAndSignatureInvoiceZatca`,
    //////////////////////Infection Control////////////
    InfectionControlCategory: `${serviceUrl}/api/v1/InfectionControlCategory`
  };
  public static Urls = {
    apiUrlNew: '',
    apiUrlOld: 'http://localhost:56278',
    reportUrl: '',
    dashboardurl: ''
  };
  public static updateOldUrl = function (url) {
    url = url.replace(CONFIG.Urls.apiUrlOld, CONFIG.Urls.apiUrlNew);
    return url
  }
}
